(function () {
  var PLAY_ONCE = false;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function escapeChar(c) {
    if (c === '&') return '&amp;';
    if (c === '<') return '&lt;';
    if (c === '>') return '&gt;';
    return c;
  }

  function init() {
    if (typeof anime === 'undefined') return;

    var slide = document.querySelector('.cc-slideshow .slideshow__slide.is-active') || document.querySelector('.cc-slideshow .slideshow__slide');
    if (!slide) return;

    var media = slide.querySelector('.image-banner__image');
    var heading = slide.querySelector('.text-overlay__heading');
    var textBlock = slide.querySelector('.text-overlay__block.rte');
    var buttons = slide.querySelector('.text-overlay__buttons');
    var subheading = slide.querySelector('.subheading');
    var isMobile = window.innerWidth < 600;

    var rays = [];
    var rayConf = [[52, 46], [66, 26], [80, 38]];
    rayConf.forEach(function (rc) {
      var r = document.createElement('div');
      r.className = 'tas-ray';
      r.style.left = rc[0] + '%';
      r.style.width = rc[1] + 'px';
      slide.appendChild(r);
      rays.push(r);
    });

    var bubbles = [];
    var nBubbles = isMobile ? 4 : 8;
    var minLeft = isMobile ? 20 : 52;
    var maxLeft = isMobile ? 85 : 92;
    for (var i = 0; i < nBubbles; i++) {
      var b = document.createElement('div');
      b.className = 'tas-bubble';
      var size = anime.random(4, 10);
      b.style.width = size + 'px';
      b.style.height = size + 'px';
      b.style.left = anime.random(minLeft, maxLeft) + '%';
      slide.appendChild(b);
      bubbles.push(b);
    }

    var letters = null;
    if (heading && !heading.querySelector('br') && !heading.querySelector('img')) {
      var txt = heading.textContent.replace(/\s+/g, ' ').trim();
      if (txt && txt.length < 60) {
        var words = txt.split(' ');
        var out = '';
        for (var w = 0; w < words.length; w++) {
          if (w > 0) out += ' ';
          out += '<span class="tas-word" style="display:inline-block;white-space:nowrap">';
          for (var j = 0; j < words[w].length; j++) {
            out += '<span class="tas-ch" style="display:inline-block">' + escapeChar(words[w][j]) + '</span>';
          }
          out += '</span>';
        }
        heading.innerHTML = out;
        letters = heading.querySelectorAll('.tas-ch');
      }
    }

    var accent = null;
    if (heading) {
      accent = document.createElement('div');
      accent.className = 'tas-accent';
      heading.parentNode.insertBefore(accent, heading.nextSibling);
    }

    var played = false;
    if (PLAY_ONCE) {
      try { played = !!sessionStorage.getItem('tasHeroPlayed'); } catch (e) {}
    }

    if (!played) {
      if (letters) anime.set(letters, { opacity: 0, translateY: 46, rotateZ: 8 });
      if (subheading) anime.set(subheading, { opacity: 0, translateY: 12 });
      if (textBlock) anime.set(textBlock, { opacity: 0, translateY: 14 });
      if (buttons) anime.set(buttons, { opacity: 0, scale: 0.85 });

      var tl = anime.timeline({ easing: 'easeOutExpo' });
      if (subheading) tl.add({ targets: subheading, opacity: [0, 1], translateY: [12, 0], duration: 500, delay: 150 });
      if (letters) tl.add({ targets: letters, opacity: [0, 1], translateY: [46, 0], rotateZ: [8, 0], duration: 850, easing: 'easeOutElastic(1, .7)', delay: anime.stagger(38, { start: subheading ? 0 : 250 }) }, subheading ? '-=250' : 0);
      if (accent) tl.add({ targets: accent, scaleX: [0, 1], duration: 550, easing: 'easeInOutQuart' }, '-=500');
      if (textBlock) tl.add({ targets: textBlock, opacity: [0, 1], translateY: [14, 0], duration: 600 }, '-=350');
      if (buttons) tl.add({ targets: buttons, opacity: [0, 1], scale: [0.85, 1], duration: 700, easing: 'easeOutElastic(1, .6)' }, '-=250');

      if (PLAY_ONCE) { try { sessionStorage.setItem('tasHeroPlayed', '1'); } catch (e) {} }
    } else if (accent) {
      accent.style.transform = 'scaleX(1)';
    }

    if (media) {
      if (!isMobile) {
        media.style.top = '-3%';
        media.style.left = '-3%';
        media.style.width = '106%';
        media.style.height = '106%';
      }
      anime({ targets: media, scale: [1, 1.06], duration: 26000, easing: 'linear' });
    }

    anime({
      targets: rays,
      opacity: [{ value: 0.5, duration: 2600 }, { value: 0.12, duration: 2600 }],
      easing: 'easeInOutSine',
      delay: anime.stagger(1400),
      loop: true
    });

    function floatBubble(b, first) {
      anime({
        targets: b,
        translateY: [0, -window.innerHeight * 0.85],
        translateX: [
          { value: anime.random(-14, 14), duration: 1600 },
          { value: anime.random(-14, 14), duration: 1600 },
          { value: anime.random(-14, 14), duration: 1600 },
          { value: anime.random(-14, 14), duration: 1600 }
        ],
        opacity: [{ value: 0.8, duration: 500 }, { value: 0.8, duration: 4400 }, { value: 0, duration: 900 }],
        scale: [1, anime.random(11, 15) / 10],
        easing: 'linear',
        duration: anime.random(5200, 8200),
        delay: first ? anime.random(0, 4500) : 0,
        complete: function () {
          anime.set(b, { translateY: 0, translateX: 0, scale: 1, opacity: 0 });
          floatBubble(b, false);
        }
      });
    }
    bubbles.forEach(function (b) { floatBubble(b, true); });

    if (!isMobile && media) {
      slide.addEventListener('mousemove', function (e) {
        var r = slide.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        anime({ targets: media, translateX: -x * 14, translateY: -y * 8, duration: 700, easing: 'easeOutQuad' });
      });
      slide.addEventListener('mouseleave', function () {
        anime({ targets: media, translateX: 0, translateY: 0, duration: 900, easing: 'easeOutQuad' });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
